import type { DefaultInput } from 'netplayjs';
import type { FrameInputState, InputEdgeState, MatchState, Rect } from './types';

export function mirrorX(x: number, stageWidth: number, entityWidth: number): number {
  return stageWidth - entityWidth - x;
}

export function overlaps(a: Rect, b: Rect): boolean {
  return (
    a.x < b.x + b.width &&
    a.x + a.width > b.x &&
    a.y < b.y + b.height &&
    a.y + a.height > b.y
  );
}

export function deriveInputEdges(
  prevJumpHeld: boolean,
  prevFireHeld: boolean,
  current: FrameInputState
): InputEdgeState {
  return {
    jumpPressed: current.jumpHeld && !prevJumpHeld,
    firePressed: current.fireHeld && !prevFireHeld,
  };
}

function readKeyHeld(input: DefaultInput | undefined, key: string): boolean {
  if (!input) return false;
  return input.keysHeld[key] === true;
}

export function mapDefaultInputToFrame(input: DefaultInput | undefined): FrameInputState {
  return {
    left: readKeyHeld(input, 'ArrowLeft') || readKeyHeld(input, 'a') || readKeyHeld(input, 'A'),
    right: readKeyHeld(input, 'ArrowRight') || readKeyHeld(input, 'd') || readKeyHeld(input, 'D'),
    jumpHeld:
      readKeyHeld(input, ' ') ||
      readKeyHeld(input, 'Spacebar') ||
      readKeyHeld(input, 'ArrowUp') ||
      readKeyHeld(input, 'w') ||
      readKeyHeld(input, 'W'),
    fireHeld: readKeyHeld(input, 'f') || readKeyHeld(input, 'F') || readKeyHeld(input, 'j') || readKeyHeld(input, 'J'),
    jetpackHeld:
      readKeyHeld(input, 'Shift') ||
      readKeyHeld(input, 'k') ||
      readKeyHeld(input, 'K'),
  };
}

export function cloneMatchState(match: MatchState): MatchState {
  return {
    status: match.status,
    winnerId: match.winnerId,
    winReason: match.winReason,
    endedFrame: match.endedFrame,
  };
}
